<template>
  <div class="white pa-4">
    <v-tabs v-model="tabsCategories" background-color="transparent" grow>
      <v-tab v-for="tab in ['Clases', 'Categorias', 'Subcategorias']" :key="tab" :href="`#${tab}`" :class="tab">
        {{ tab }}
      </v-tab>
    </v-tabs>
    <!-- Clase de clientes start -->
    <v-tabs-items v-model="tabsCategories">
      <v-tab-item value="Clases">
        <v-row style="padding: 10px">
          <v-col cols="12">
            <h2 style="text-align: center">Clases</h2>
          </v-col>
          <v-row class="mt-4">
            <v-col cols="12" md="6">
              <v-text-field outlined dense v-model="className" label="Nombre de Clase" required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex justify-end">
                <v-btn class="btn-save mr-5" @click.prevent.stop="addClass()">
                  Agregar Clase
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-col cols="12">
            <!-- Table Classes start -->
            <GeneralFilter entity="lista" :filterEndpoint="$API.customersTypes.getClassesFiltered" :search="search"
              @emptyFilter="getClasses" @filtered="filterHandlerClasses">
              <DxDataGrid class="isScrolledByGeneralFilter" :show-borders="true" :data-source="classes" key-expr="id">
                <DxColumn :width="70" cell-template="show-delete" caption=""></DxColumn>
                <DxColumn :width="70" cell-template="show-template" caption="Clases"></DxColumn>
                <DxPaging :page-size="10" />
                <DxColumn data-field="name" caption="Nombre"></DxColumn>

                <!--  <DxColumn data-field="TypeOfImage" caption="Tipo de Imágen"></DxColumn> -->

                <template #show-delete="{ data }">
                  <div>
                    <a href="" class="mx-2" @click.prevent.stop="
                      toDelete = data.data.id;
                    showAlert(
                      'question',
                      'Eliminar Elemento',
                      '¿Está seguro que desea eliminar este Elemento?',
                      'destroyClass'
                    );
                    ">
                      <v-icon color="error">mdi-delete</v-icon>
                    </a>
                  </div>
                </template>
                <template #show-template="{ data }">
                  <div>
                    <a href="#" @click.prevent.stop="
                      (form.class = data.data.id),
                      (showClassCat = data.data.name),
                      (form.category = null),
                      (tabsCategories = 'Categorias')
                        (selectClass())
                      ">
                      <v-icon color="primary">mdi-eye</v-icon>
                    </a>
                    <!--      <a href="" class="mx-2" @click.prevent.stop="showDelete(data.data.ID_Images)">

                                <v-icon color="error">mdi-delete</v-icon>
                              </a> -->
                  </div>
                </template>
                <DxPager :show-page-size-selector="true" />
                <DxPaging :page-size="5" />
              </DxDataGrid>
            </GeneralFilter>
            <!-- Table classes end -->
          </v-col>

        </v-row>
      </v-tab-item>
      <!-- Clase de clientes end -->

      <!-- Categoria de clientes start -->
      <v-tab-item value="Categorias">
        <v-row style="padding: 10px" v-if="form.class">
          <v-col cols="12">
            <h2 style="text-align: center">
              Categoria de clientes <span> (clase {{ showClassCat }}) </span>
            </h2>
          </v-col>
          <v-row class="mt-4">
            <v-col cols="12" md="6">
              <v-text-field outlined dense v-model="categoryName" label="Nombre de Categoria" required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex justify-end">
                <v-btn class="btn-save mr-5" @click.prevent.stop="addCategory(form.class)">
                  Agregar Categoria
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-col cols="12">
            <!-- Table category start -->
            <GeneralFilter entity="categoria" :filterEndpoint="$API.customersTypes.getCategoriesFiltered" :search="search"
              @emptyFilter="getCategories" @filtered="filterHandlerCategories">
              <DxDataGrid class="isScrolledByGeneralFilter" :show-borders="true" :data-source="filteredCategories"
                key-expr="id">
                <DxColumn :width="70" cell-template="show-delete" caption=""></DxColumn>
                <DxColumn :width="120" cell-template="show-template" caption="Categorías"></DxColumn>
                <DxPaging :page-size="10" />
                <DxColumn data-field="name" caption="Nombre"></DxColumn>

                <!--  <DxColumn data-field="TypeOfImage" caption="Tipo de Imágen"></DxColumn> -->

                <template #show-delete="{ data }">
                  <div>
                    <a href="" class="mx-2" @click.prevent.stop="
                      toDelete = data.data.id;
                    showAlert(
                      'question',
                      'Eliminar Elemento',
                      '¿Está seguro que desea eliminar este Elemento?',
                      'destroyCat'
                    );
                    ">
                      <v-icon color="error">mdi-delete</v-icon>
                    </a>
                  </div>
                </template>
                <template #show-template="{ data }">
                  <div>
                    <a href="#" @click.prevent.stop="
                      (showCatSub = data.data.name),
                      (form.category = data.data.id),
                      (tabsCategories = 'Subcategorias')
                        (selectCategory())
                      ">
                      <v-icon color="primary">mdi-eye</v-icon>
                    </a>
                    <!--      <a href="" class="mx-2" @click.prevent.stop="showDelete(data.data.ID_Images)">

                                <v-icon color="error">mdi-delete</v-icon>
                              </a> -->
                  </div>
                </template>
                <DxPager :show-page-size-selector="true" />
                <DxPaging :page-size="5" />
              </DxDataGrid>
            </GeneralFilter>
            <!-- Table category end -->
          </v-col>

        </v-row>
        <v-row v-else>
          <div class="pa-5 d-flex justify-content-center">
            <h2>
              Seleccione una clase para poder agregar una categoria
            </h2>
          </div>
        </v-row>
      </v-tab-item>
      <!-- Categoria de clientes end -->

      <!-- SubCategoria de clientes start -->
      <v-tab-item value="Subcategorias">
        <v-row style="padding: 10px" v-if="form.category">
          <v-col cols="12">
            <h2 style="text-align: center">
              SubCategoria de clientes
              <span>(categoria {{ showCatSub }})</span>
            </h2>
          </v-col>
          <v-row class="mt-4">
            <v-col cols="12" md="6">
              <v-text-field outlined dense v-model="subName" label="Nombre de SubCategoria" required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex justify-end">
                <v-btn class="btn-save mr-5" @click.prevent.stop="addSub(form.category)">
                  Agregar SubCategoria
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-col cols="12">
            <!-- Table subcategory start -->
            <GeneralFilter entity="lista" :filterEndpoint="$API.customersTypes.getSubsFiltered" :search="search"
              @emptyFilter="getSubs" @filtered="filterHandlerSubs">
              <DxDataGrid class="isScrolledByGeneralFilter" :show-borders="true" :data-source="filteredSubcategories"
                key-expr="id">
                <DxColumn :width="70" cell-template="show-delete" caption="Subcategorías"></DxColumn>
                <!--   <DxColumn :width="70" cell-template="show-template" caption="Ver Categorias"></DxColumn> -->
                <DxPaging :page-size="10" />
                <DxColumn data-field="name" caption="Nombre"></DxColumn>

                <!--  <DxColumn data-field="TypeOfImage" caption="Tipo de Imágen"></DxColumn> -->

                <template #show-delete="{ data }">
                  <div>
                    <a href="" class="mx-2" @click.prevent.stop="
                      toDelete = data.data.id;
                    showAlert(
                      'question',
                      'Eliminar Elemento',
                      '¿Está seguro que desea eliminar este Elemento?',
                      'destroySub'
                    );
                    ">
                      <v-icon color="error">mdi-delete</v-icon>
                    </a>
                  </div>
                </template>
                <template #show-template="{ data }">
                  <div>
                    <a href="#" @click.prevent.stop="showClassCat = data.data.id">
                      <v-icon color="primary">mdi-eye</v-icon>
                    </a>
                  </div>
                </template>
                <DxPager :show-page-size-selector="true" />
                <DxPaging :page-size="5" />
              </DxDataGrid>
            </GeneralFilter>
            <!-- Table subcategory end -->
          </v-col>

        </v-row>
        <v-row v-else>
          <div class="pa-5 d-flex justify-content-center">
            <h2>
              Seleccione una categoria para poder agregar una subcategoria
            </h2>
          </div>
        </v-row>
      </v-tab-item>
      <!-- SubCategoria de clientes end -->
    </v-tabs-items>



    <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
    </alerts>
  </div>
</template>

<script>

//import {mapState} from 'vuex';
import alerts from '@/components/Alerts.vue';
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,

} from "devextreme-vue/data-grid";
import GeneralFilter from "@/components/GeneralFilter";

export default {
  name: "ManageCategoryCustomers",
  components: {
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    alerts,
    GeneralFilter,
  },
  props: {
    win: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      classes: [],
      filteredCategories: [],
      filteredSubcategories: [],
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      form: {
        class: null,
        category: null,
        subcategory: null,
      },
      tabsCategories: null,
      className: null,
      categoryName: null,
      subName: null,
      showClassCat: null,
      showCatSub: null,
      toDelete: null,
      search: {
        filter: null,
      },
    }
  },
  mounted() {
    this.getClasses();
  },
  methods: {
    getClasses() {
      this.$API.customersTypes.getClasses().then((response) => {
        this.classes = response;
      });
    },
    getCategories() {
      this.$API.customersTypes.getCategories().then((response) => {
        this.filteredCategories = response.filter(element => element.id_class === this.form.class);
      });
    },
    getSubs() {
      this.$API.customersTypes.getSubs().then((response) => {
        this.filteredSubcategories = response.filter(element => element.id_cat === this.form.category);
      });
    },
    addClass() {
      this.$API.customersTypes.createClass(this.className).then(() => {
        this.className = null;
        this.getClasses();
        this.showAlert(
          "success",
          "Exito",
          "La clase se agregó de forma correcta"
        );
        this.$emit('reloadCategories');
      });
    },
    addCategory(id_class) {
      let toSend = {
        name: this.categoryName,
        id_class: id_class,
      };
      this.$API.customersTypes.createCat(toSend).then(() => {
        this.getClasses();
        this.categoryName = null;
        this.getCategories();
        this.showAlert(
          "success",
          "Exito",
          "La categoría se agregó de forma correcta"
        );
        this.selectClass();

      });
    },
    addSub(id_cat) {
      let toSend = {
        name: this.subName,
        id_cat: id_cat,
      };
      this.$API.customersTypes.createSub(toSend).then(() => {
        this.subName = null;
        this.getClasses();
        this.getCategories();
        this.getSubs();
        this.showAlert(
          "success",
          "Exito",
          "La Subcategoria se agregó de forma correcta"
        );
        this.selectCategory();
      });
    },
    filterHandlerClasses(response) {
      this.classes = response;
    },

    filterHandlerCategories(response) {
      this.filteredCategories = response.filter(element => element.id_class === this.form.class);
    },

    filterHandlerSubs(response) {
      this.filteredSubcategories = response.filter(element => element.id_cat === this.form.category);
    },
    destroyClass(id) {
      this.$API.customersTypes.deleteClass(id).then(() => {
        this.getClasses();
        this.showAlert("success", "Exito", "Se eliminó de forma correcta");
        this.$emit('reloadCategories');
      });
    },
    destroyCat(id) {
      this.$API.customersTypes.deleteCat(id).then(() => {
        this.getCategories();
        this.showAlert("success", "Exito", "Se eliminó de forma correcta");
        this.selectClass()
      });
    },
    destroySub(id) {
      this.$API.customersTypes.deleteSub(id).then(() => {
        this.getSubs();
        this.showAlert("success", "Exito", "Se eliminó de forma correcta");
        this.selectCategory();
      });
    },
    closeAlert() {
      this.alert.show = false;

    },
    acceptAlert() {
      this.alert.show = false;
      //this.$store.dispatch("deleteWindowByUuid", { uuid: this.win.uuid }); falta el id
      //this.$store.dispatch('addWindow',{'name':'ProductsList',component:'ProductsList',unique:false});
      if (this.alert.options == "destroyClass") {
        this.destroyClass(this.toDelete);
      }
      if (this.alert.options == "destroyCat") {
        this.destroyCat(this.toDelete);
      }

      if (this.alert.options == "destroySub") {
        this.destroySub(this.toDelete);
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    async selectClass() {
      this.filteredCategories = await this.$API.customersTypes.getCategoriesByClass({ id_class: this.form.class });
    },
    async selectCategory() {
      this.filteredSubcategories = await this.$API.customersTypes.getSubsByCategory({ id_cat: this.form.category });
    }
  },


}
</script>

<style scoped></style>